import { CompassIcon } from '@phosphor-icons/react';
import type { JSX } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

export function NotFound(): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center space-y-4">
      <CompassIcon size={48} className="text-muted-foreground" weight="duotone" />
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="text-sm text-muted-foreground max-w-md">
        We couldn&apos;t find the page you&apos;re looking for. It might have moved, or it might be
        scheduled for a later phase.
      </p>
      <Button asChild>
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
